import { render, staticRenderFns } from "./searchCollege.vue?vue&type=template&id=34ea719a&scoped=true"
import script from "./searchCollege.vue?vue&type=script&lang=js"
export * from "./searchCollege.vue?vue&type=script&lang=js"
import style0 from "./searchCollege.vue?vue&type=style&index=0&id=34ea719a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ea719a",
  null
  
)

export default component.exports